module.exports = __webpack_public_path__ + "static/media/si_3.abc28cc1.JPG";